import React from 'react'
import { useLocation } from 'react-router-dom'
// import TeacherModal from '../teacherModal'
import AdminModal from '../adminModal'
// import TeacherBreadcrumb from './teacherBreadcrumb'
import AdminBreadcrumb from './adminBreadcrumb'

const AdminDetails = () => {
    const location = useLocation();
    const teacherFromState = location.state?.teacher;
    console.log("Teacher Details:", location.state);
    
    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        {/* Page Header */}
                        <AdminBreadcrumb teacherFromState={teacherFromState}/>
                        {/* /Page Header */}
                    </div>
                    <div className="row">
                        {/* /Teacher Information */}
                        <div className="col-xxl-9 col-xl-8">
                            <div className="row">
                                <div className="col-md-12">
                                    {/* Basic Information */}
                                    <div className="card">
                                        <div className="card-header">
                                            <h5>Basic Information</h5>
                                        </div>
                                        <div className="card-body">
                                            <div className="border rounded p-3 pb-0">
                                                <div className="row">
                                                    <div className="col-sm-6 col-lg-4">
                                                        <div className="mb-3">
                                                            <p className="text-dark fw-medium mb-1">
                                                                First Name
                                                            </p>
                                                            <p>{teacherFromState?.firstName || 'N/A'}</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6 col-lg-4">
                                                        <div className="mb-3">
                                                            <p className="text-dark fw-medium mb-1">
                                                                Last Name
                                                            </p>
                                                            <p>{teacherFromState?.lastName || 'N/A'}</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6 col-lg-4">
                                                        <div className="mb-3">
                                                            <p className="text-dark fw-medium mb-1">Email</p>
                                                            <p>{teacherFromState?.email || 'N/A'}</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6 col-lg-4">
                                                        <div className="mb-3">
                                                            <p className="text-dark fw-medium mb-1">
                                                                Phone Number
                                                            </p>
                                                            <p>{teacherFromState?.phone || 'N/A'}</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6 col-lg-4">
                                                        <div className="mb-3">
                                                            <p className="text-dark fw-medium mb-1">
                                                                Aadhar Number
                                                            </p>
                                                            <p>{teacherFromState?.aadharNumber || 'N/A'}</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6 col-lg-4">
                                                        <div className="mb-3">
                                                            <p className="text-dark fw-medium mb-1">Designation</p>
                                                            <p>{teacherFromState?.designation || 'N/A'}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* /Basic Information */}
                                </div>
                                
                                {/* Role Information */}
                                <div className="col-xxl-6 d-flex">
                                    <div className="card flex-fill">
                                        <div className="card-header">
                                            <h5>Role Information</h5>
                                        </div>
                                        <div className="card-body">
                                            <div className="mb-3">
                                                <p className="text-dark fw-medium mb-1">
                                                    Assigned Roles
                                                </p>
                                                <div>
                                                    {teacherFromState?.roleNames?.length > 0 ? (
                                                        teacherFromState.roleNames.map((role:any, index:any) => (
                                                            <span key={index} className="badge bg-primary me-1 mb-1">
                                                                {role}
                                                            </span>
                                                        ))
                                                    ) : (
                                                        <span className="badge bg-secondary">No roles assigned</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <p className="text-dark fw-medium mb-1">
                                                    Teacher ID
                                                </p>
                                                <p>{teacherFromState?.id ?? 'N/A'}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* /Role Information */}
                                
                                {/* Contact Information */}
                                <div className="col-xxl-6 d-flex">
                                    <div className="card flex-fill">
                                        <div className="card-header">
                                            <h5>Contact Information</h5>
                                        </div>
                                        <div className="card-body">
                                            <div className="d-flex align-items-center mb-3">
                                                <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                                                    <i className="ti ti-mail" />
                                                </span>
                                                <div>
                                                    <p className="text-dark fw-medium mb-1">
                                                        Email Address
                                                    </p>
                                                    <p>{teacherFromState?.email ?? 'N/A'}</p>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                                                    <i className="ti ti-phone" />
                                                </span>
                                                <div>
                                                    <p className="text-dark fw-medium mb-1">
                                                        Phone Number
                                                    </p>
                                                    <p>{teacherFromState?.phone ?? 'N/A'}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* /Contact Information */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Page Wrapper */}
            <AdminModal />
        </>
    )
}

export default AdminDetails 